/**
 * Entity Records Page
 *
 * Displays list of records for a specific entity type.
 */

import { Box, useI18n } from '@ops-matrix/design-system-ui';
import { useParams } from 'react-router-dom';
import EntityRecordList from '../../components/entity/EntityRecordList';
import { PageTemplate } from '../../components/layout/PageTemplate';

export default function EntityRecordsPage() {
  const { entityId } = useParams<{ entityId: string }>();
  const { t } = useI18n();

  if (!entityId) {
    return (
      <PageTemplate variant="list">
        <Box sx={{ textAlign: 'center', py: 4 }}>{t('consumer.entity.entityTypeNotSpecified')}</Box>
      </PageTemplate>
    );
  }

  return (
    <PageTemplate variant="list">
      <EntityRecordList entityId={entityId} />
    </PageTemplate>
  );
}
